import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What is included in the USA Nail License State Guide?',
  answer: 'This comprehensive guide covers licensing requirements for all 50 states, including which states require formal licensing, how to operate legally in states with minimal requirements, and step-by-step instructions for obtaining your license or operating as an independent contractor in your specific state.'
}, {
  question: 'Do I need a SSN to handle taxes as a nail tech?',
  answer: 'The Nail Tech Tax Essentials bonus explains how to obtain an EIN or ITIN to operate your business legally and file taxes correctly, even if you are in the middle of an immigration process. You will learn what expenses to track to set aside money for taxes, and stay IRS‑compliant from day one.'
}, {
  question: 'How do I attract clients if I just starting out?',
  answer: 'The 30 Days of TikTok Hooks bonus gives you ready-to-use scripts and content ideas specifically designed for nail techs. You will get proven hooks that attract local clients, build trust, and turn viewers into paying customers, no guessing, no wasted time figuring out what to post.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-slate-50" data-id="element-5">
      <div className="max-w-3xl mx-auto" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-7">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-8">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-600" data-id="element-9">
            Everything you need to know before getting started.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-10">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-11">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500" data-id="element-12">
                <span className="font-bold text-slate-900 text-lg" data-id="element-13">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-14" />
              </button>

              <AnimatePresence data-id="element-15">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-16">
                    <div className="px-6 pb-5 pt-0 text-slate-600 border-t border-slate-100 mt-2 pt-4" data-id="element-17">
                      <p className="leading-relaxed" data-id="element-18">{faq.answer}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}